interface RowData {
  name: string;
  family: string;
  given: string;
}

export interface INamingGuideline {
  header: { id: string, label: string } [],
  source: {
    key: string;
    data: RowData[]
  }[]
}

export const NamingGuidelineTemplate: INamingGuideline = {
  header: [{ id: "name", label: "Ethnicity / Example" }, { id: "family", label: "Family name" }, { id: "given", label: "Given name" }],
  source: [
    {
      key: "Chinese",
      data: [
        {
          name: "Lee Xiao Ming John",
          family: "Lee",
          given: "Xiao Ming John"
        },
        {
          name: "John Lee Xiao Ming",
          family: "John",
          given: "Lee Xiao Ming"
        },
      ]
    },
    {
      key: "Malay",
      data: [
        {
          name: "Afiq Mohd Ahmad",
          family: "Mohd Ahmad",
          given: "Afiq"
        },
        {
          name: "Nurul Bte Ali",
          family: "Bte Ali",
          given: "Nurul"
        },
      ]
    },
    {
      key: "Indian",
      data: [
        {
          name: "Hamid Radha",
          family: "Radha",
          given: "Hamid"
        },
        {
          name: "Danish S/O Radha",
          family: "S/O Radha",
          given: "Danish"
        },
      ]
    },
    {
      key: "Others (Caucasian)",
      data: [
        {
          name: "Harry Potter",
          family: "Potter",
          given: "Harry"
        },
        {
          name: "Brad Pitt Man",
          family: "Man",
          given: "Brad Pitt"
        },
      ]
    }
  ]
}